<template>
    <div class="container">
        <ProductsMenu @productsSelect="productsSelect"/>
        <div>
           <div class="title" data-aos="fade-up">BioFactory临床数据与样本资源库管理系统</div>
           <div class="titleBorder" data-aos="fade-up"></div>
           <div class="introduction">
               <img :src="require('@/assets/img/products/tissuebank/index.png')"  data-aos="flip-down">
               <div>
                    <div data-aos="fade-up">上海唐颐信息技术有限公司作为“全国生物样本标准化技术委员会”信息化标准的主要起草者，核心团队历经15年积累，在服务300多家大型三甲医院、知名高校、研究所、企业等客户的过程中，持续优化生物样本库产品，目前已成功进行8次迭代。</div>
                    <div data-aos="fade-up">”BioFactory临床数据与样本资源库管理系统“实现了对生物样本全生命周期的规范管理，具有采集可追溯、信息化管理、质量控制及数据分析等优势，有效保障生物样本的高质量与可靠性，系统涵盖旗舰版、专业版、基础版等5大版本，精准适配不同类型用户与功能要求等，帮助科研工作者更加快速高效地实现科研成果产出。</div>
<!--                    <div data-aos="fade-up">目前，唐顾BioFactorv系统整合了高质量的规范化临床信息、组学信息，依托唐顾首席科学家刘雷教授疾病研究精准医学知识库项目成果，建设科研大数据分析挖掘平台，帮助科研工作更快速高效地实现科研成果产出。</div>-->
               </div>
           </div>
           <div class="advantage">
                <div class="advantageTitle" data-aos="zoom-in-up">
<!--                    <img :src="require('@/assets/img/products/tissuebank/advantageTitle.png')" alt="" style="margin-right: 10px;vertical-align: text-bottom">-->
                    产品优势
                </div>
                <div class="content">
                    <div data-aos="fade-up-right">
                        <div class="redBorder"></div>
                        <div class="whiteSpace"></div>
                        <div class="text">10余年系统<br>稳定升级</div>
                    </div>
                    <div data-aos="fade-up">
                        <div class="redBorder"></div>
                        <div class="whiteSpace"></div>
                        <div class="text">高效实用<br>模块化功能</div>
                    </div>
                    <div  data-aos="fade-up-left">
                        <div class="redBorder"></div>
                        <div class="whiteSpace"></div>
                        <div class="text">院内多科室<br>共享体系</div>
                    </div>
                </div>
               <img :src="require('@/assets/img/products/tissuebank/advantageMap.png')" alt="" style="margin: 0 auto" data-aos="zoom-in">
           </div>
           <div class="function">
                <div class="functionTitle" data-aos="zoom-in-up">功能介绍</div>
                <div class="functionIntroduction" data-aos="fade-up">唐颐BioFactory可帮助样本库管理人员安全保藏样本，包括从样本采集、样本接收、样本叠记、样本处理、样本入库、质检、及盘库等全流程高质量高效率管理。</div>
                <div class="functionContent">
                    <div v-for="item,index in functionList" :data-aos="index>2?'fade-left':'fade-right'" >
                        <img :src="item.src" :alt="item.title">
                        <div>{{item.title}}</div>
                    </div>
                </div>
                <div class="functionIntroduction" data-aos="fade-up">同时,系统以科研为导向,可帮助科研人员快速入组实验对象,提供相应高质量数据与实体样本,并且提供―系列科研相关模块,包括队列管理、家系管理、项目管理等。目前,BioFactory系统整合了高质量的标准化临床信息和组学信息,依托唐顾首席科学家刘雷教授疾病研究精准医学知识库项目成果,建设科研大数据分析挖掘平台,帮助科研工作者更快速高效地实现科研成果产出。</div>
                <div class="functionTitle" data-aos="zoom-in-up">功能示例</div>
                <div class="functionIntroductionList">
                    <div v-for="item in functionIntroductionList">
                        <div class="introductionLeft" data-aos="fade-up"><img :src="item.img" alt="" ></div>
                        <div class="introductionRight">
                            <div v-for="list in item.list" data-aos="fade-up">{{list}}</div>
                        </div>
                    </div>
                </div>
           </div>
           <div class="tissueFooter">
               <div>
                    <div class="footerTitle"  data-aos="fade-up">【 产品首页 】</div>
               </div>
                <el-carousel :interval="4000" type="card" height="345px" class="footerCarousel" indicator-position="none" data-aos="zoom-in">
                    <el-carousel-item v-for="item,index in productsList" :key="'products'+index">
                      <img :src="item" alt="" style="width: 100%;height: 100%">
                    </el-carousel-item>
                </el-carousel>
               <div>
               <div class="productsTitle" data-aos="zoom-in-up">产品系列</div>
                <table class="productsList">
                        <thead>
                            <tr  data-aos="fade-up">
                                <td>产品系列</td>
                                <td>功能模块</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr  data-aos="fade-up">
                                <td>标准版</td>
                                <td>存储容器、房间管理、盒子管理、样本登记、出入还销、单据管理、统计;</td>
                            </tr>
                            <tr data-aos="fade-up">
                                <td>专业版</td>
                                <td>自动入库、容器转移、样本采集、样本接收、样本登记、样本处理、样本质检、样本盘库、出入还销、单据管理、样本预警、组合查询、项目管理、样本质量说明书、人遗年报;</td>
                            </tr>
                            <tr  data-aos="fade-up">
                                <td>旗舰版</td>
                                <td>自动入库、容器转移、样本采集、样本接收、样本登记、样本处理、样本质检、样本盘库、出入还销、单据管理、样本预警、组合查询、样本质量说明书、人遗年报;项目管理、项目概览、工作台、SOP管理、项目规划;</td>
                            </tr>
                        </tbody>
                    </table>
               </div>
           </div>
        </div>
    </div>
</template>

<script>
import ProductsMenu from "../../components/ProductsMenu";

export default {
	components: {ProductsMenu},
	data() {
		return {
		    functionList:[{
		        title:'采集',
                src:require('@/assets/img/products/tissuebank/function1.png')
            },{
		        title:'处理',
                src:require('@/assets/img/products/tissuebank/function2.png')
            },{
		        title:'入库',
                src:require('@/assets/img/products/tissuebank/function3.png')
            },{
		        title:'实验',
                src:require('@/assets/img/products/tissuebank/function4.png')
            },{
		        title:'质控',
                src:require('@/assets/img/products/tissuebank/function5.png')
            },{
		        title:'随访',
                src:require('@/assets/img/products/tissuebank/function6.png')
            }],
            functionIntroductionList:[
                {
                    img:require('@/assets/img/products/tissuebank/functionList1.png'),
                    list:['容器','存储容器','房间管理','盒子管理','容器属性设置','容器转移']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList2.png'),
                    list:['样本','样本列表','样本采集','样本接收','样本登记','样本处理','样本入库','样本质检','样本预警','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList3.png'),
                    list:['样本源','样本源管理','知情同意','病例管理']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList4.png'),
                    list:['统计','样本质量说明书','人遗年报','统计图表','统计报表','组合查询']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList5.png'),
                    list:['项目管理','项目概览','工作台','存储规格','SOP管理','项目公告']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList6.png'),
                    list:['统计分析','统计图表','统计报表','成本管理','温度信息管理']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList7.png'),
                    list:['随访','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList8.png'),
                    list:['质控','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList9.png'),
                    list:['组学','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList10.png'),
                    list:['队列','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList11.png'),
                    list:['家系','......']
                },
                {
                    img:require('@/assets/img/products/tissuebank/functionList12.png'),
                    list:['共享','......']
                },
            ],
            productsList:[
                require('@/assets/img/products/tissuebank/products1.png'),
                require('@/assets/img/products/tissuebank/products2.png'),
                require('@/assets/img/products/tissuebank/products3.png'),
                require('@/assets/img/products/tissuebank/products4.png'),
                require('@/assets/img/products/tissuebank/products5.png'),
                require('@/assets/img/products/tissuebank/products6.png'),
            ]
        }
	},
    methods:{
	    productsSelect(src){
	        this.$emit('productsSelect',src)
        }
    }
}
</script>

<style lang="less" scoped>
    .container{
        width: 100%;
        padding-left: 20%;
        box-sizing: border-box;
        position: relative;
    }
    .title{
        font-size: 27px;
        margin-top: 213px;
        text-align: center;
        margin-bottom: 20px;
    }
    .titleBorder{
        width: 47px;
        height: 5px;
        background: #ed1c24;
        margin: 0 auto;
    }
    .introduction{
        width: 1170px;
        margin: 76px auto 100px;
        display: flex;
        justify-content: space-between;
        &>div{
            width: 610px;
            padding-top: 18px;
            font-size: 14px;
            line-height: 30px;
            letter-spacing: 1px;
            text-indent: 2em;
            color: rgb( 51, 51, 51 );
        }
    }
    .advantage{
        width: 1176px;
        margin: 0 auto 134px;
        .advantageTitle{
            margin-left: 128px;
            width: 126px;
            height: 29px;
            color: #fff;
            background: #006efd;
            text-align: center;
            line-height: 27px;
            font-weight: bold;
            letter-spacing: 4px;
        }
        .content{
            width: 100%;
            margin: 0 auto;
            padding-top: 70px;
            padding-left: 180px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            &>div{
                width: 300px;
                height: 212px;
                position: relative;
                .redBorder{
                    position: absolute;
                    z-index: 1;
                    width: 175px;
                    height: 175px;
                    box-sizing: border-box;
                    border: 9px solid #006efd;
                    border-radius: 50%;
                }
                .whiteSpace{
                    position: absolute;
                    z-index: 2;
                    width: 175px;
                    height: 142px;
                    background: #fff;
                }
                .text{
                    position: absolute;
                    z-index: 3;
                    width: 175px;
                    height: 167px;
                    border:1px solid #e1e1e1;
                    border-radius: 50%;
                    border-bottom-color: #006efd;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    text-align: center;
                    font-size: 21px;
                    line-height: 30px;
                    font-weight: bold;
                    box-sizing: border-box;
                    padding-top: 10px;
                }
            }
        }
    }
    .function{
        width: 986px;
        margin: 0 auto 134px;
        .functionTitle{
            width: 126px;
            height: 29px;
            color: #fff;
            background: #006efd;
            text-align: center;
            line-height: 27px;
            font-weight: bold;
            letter-spacing: 4px;
            margin-bottom: 39px;
        }
        .functionIntroduction{
            box-sizing: border-box;
            font-size: 15px;
            letter-spacing: 1px;
            line-height: 30px;
            margin-bottom: 39px;
        }
        .functionContent{
            height: 255px;
            background: #eee;
            padding: 70px;
            box-sizing: border-box;
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            margin-bottom: 39px;
            &>div{
                text-align: center;
                img{
                    margin-bottom: 35px;
                }
                div{
                    font-size: 14px;
                    letter-spacing: 2px;
                }
            }
        }
        .functionIntroductionList{
            width: 100%;
            display: flex;
            justify-content: space-between;
            flex-wrap: wrap;
            padding-left: 10px;
            padding-top: 45px;
            &>div{
                width: 160px;
                display: flex;
                margin-bottom: 35px;
                .introductionLeft{
                    margin-right: 6px;
                }
                .introductionRight{
                    div{
                        font-size: 15px;
                        line-height: 21px;
                        letter-spacing: 1px;
                    }
                    &>div:nth-child(1){
                        margin-bottom: 10px;
                    }
                }
            }
        }
    }
    .tissueFooter{
        width: 100%;
        background: #faf9f9;
        padding-bottom: 44px;
        &>div{
             width: 986px;
             margin: 0 auto;
            .footerTitle{
                width: 100%;
                height: 160px;
                line-height: 160px;
                text-align: center;
                font-size: 19px;
                color: #006efd;
                letter-spacing: 2px;
            }
            .productsTitle{
                width: 126px;
                height: 29px;
                color: #fff;
                background: #006efd;
                text-align: center;
                line-height: 27px;
                font-weight: bold;
                letter-spacing: 4px;
                margin:150px 0 52px 0;
            }
            .productsList{
                margin: 0px auto;
                thead{
                    td{
                        height: 36px;
                        background: #006efd;
                        color: #fff;
                        font-size: 15px;
                        text-align: center;
                        letter-spacing: 1px;
                    }
                }
                tbody{
                    tr{
                        border-bottom: 3px solid #faf9f9;
                        border-top: 3px solid #faf9f9;
                        font-size: 15px;
                        td{
                            padding: 0 40px;
                            line-height: 30px;
                            letter-spacing: 1px;
                            box-sizing: border-box;
                        }
                        td:nth-child(1){
                            width: 282px;
                            height: 122px;
                            text-align: center;
                            background: #fff;
                            font-size: 19px;
                            font-weight: bold;
                            color: #006efd;
                        }
                        td:nth-child(2){
                            width: 691px;
                            height: 122px;
                            background: #fff;
                        }
                    }
                }
            }
        }
        &>div:nth-child(2){
            width: 1360px;
            /deep/
            .el-carousel__mask{
                background: #000;
                opacity: 0.6;
            }
        }
    }



</style>
